class RelatedVideos extends HTMLElement {
    constructor() {
      super();
      
      this.selectors = {
        'relatedItems': '.product-related-information',
        'playButton': '.js-related-video-play'
      }

      this.query = this.dataset.query
      this.videos = []
      this.sortedVideos = [];
      this.wrapper = this;
      this.videosContainer = this.querySelector('.js-related-videos-slider')
      this.$videosContainer = $(this.videosContainer);
      this.openPopup = this.dataset.openPopup || false
      this.playlist = [];
      this.playlistData = {
        title: `${decodeURI(this.dataset.playlistTitle)}`,
        title2: `${decodeURI(this.dataset.playlistTitle2)}`,
        mobileTitle: `${decodeURI(this.dataset.playlistMobileTitle)}`
      }

      this.relatedCollectionVideosMetafield = window.relatedCollectionVideos || [];
      

      this.init();     

  }
  

  async init() {
    await this.retrieveVideos();
    this.buildSection();
    this.setupEventListeners();
    document.dispatchEvent(new Event(`${this.id}.loaded`))
    
  }

  getFirstVideoBlog(){
    //if video blog exist get data
    if(!this.classList.contains('related-video-section--has-video-blog')) return false;

    return {
      url: false,
      title: this.dataset.videoBlogTitle,
      thumb: this.dataset.videoBlogThumb,
      category: '',
      videoType: "related",
      video: this.dataset.videoBlog
    }
  }

  async retrieveVideos() {
    const url = window.Shopify.routes.root + 'search?view=videoBlog-ajax&type=article&q=' + this.query;
    
    try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Response status: ${response.status}`);
        }
    
      let data = await response.json();
      
      this.videos = data.results;
    
    } catch (error) {
      console.error(error.message);
      this.hide();
    }
  }

  popLatestVideo() {

    if (this.$videosContainer.hasClass('slick-initialized')) {
      this.$videosContainer.slick('slickRemove', 0);
    } else {
      this.$videosContainer.children(":first").remove();
    }

    return this.sortedVideos.shift();
  }

  setupEventListeners() {
    

    window.addEventListener('resize', throttle(this.handleResize.bind(this), 500))
    /*
    $(window).on('resize', throttle(function() {
      if( $(window).width() > 768 &&  !$videosContainer.hasClass('slick-initialized')) {
        slickInit();
      }
    }, 500));
    */

    if (this.openPopup) {
      this.querySelectorAll(this.selectors.playButton).forEach((item) => {
          //make sure to trigger analytics before the handle play because of prevent default
          if(item.classList.contains('js-analytics-trigger')) item.addEventListener('click', handleAnalyticsClick);

          item.addEventListener('click', this.handlePlay.bind(this));
      })
    }

  }

  handleResize() {
    let $videosContainer = this.$videosContainer;
    //let slickInit = this.slickInit;

    if( $(window).width() > 768 &&  !$videosContainer.hasClass('slick-initialized')) {
      this.slickInit();
    }
  }

  buildPlaylist(videos) {
    for(let i = 0; i < videos.length; i++){
        let item = videos[i];
        var video = item.video
        var thumb = item.thumb
        var category = item.category
        var title = item.title
        var video_type = item.videoType
        
        var data = {
          name: title,
          description: category,
          video_type: video_type,
          autoplay: true,
          sources: [
            { src: video, type: 'video/mp4'}
          ],
          aspectRatio: "16:9",
          thumbnail:[
            { src: thumb }
          ]
        }
  
        this.playlist.push(data);
      }
  }

  handlePlay(event) {
    event.preventDefault();
    event.stopPropagation();

    let element = event.target;
    let src = element.dataset.video;

    if (!src || src == "") return;

    //initplaylist takes playlist item and title
    document.querySelector(this.openPopup).initPlaylist(this.playlist, this.playlistData);
    document.querySelector(this.openPopup).open(src);
  }

  hide() {
    this.wrapper.style.display = "none";
  }

  
  sortByDate(data) {
      return data.toSorted(function(a,b){
        return new Date(b.published_at) - new Date(a.published_at);
      })
  }

  buildSection() {

    let firstVideo = this.getFirstVideoBlog();
    let relatedCollectionVideos = this.relatedCollectionVideosMetafield;

    if (this.videos.length == 0 && relatedCollectionVideos.length == 0 && !firstVideo) {
      this.hide();
      return;
    }

    let priorityItems = [];
    let itemsCopy = [];

    for (let i = 0; i < this.videos.length; i++){
      let item = this.videos[i];
      if(item.priority){
        priorityItems.push(item);
      }else{
        itemsCopy.push(item);
      }
      
      /*
      if(item.watch){
        initProductWatchIcon(item);
      }
      */
      
    }

    priorityItems = this.sortByDate(priorityItems);
    itemsCopy = this.sortByDate(itemsCopy);

    
    //merge two arrays priority first
    let items = [...priorityItems, ...itemsCopy];

    //prepend first video
    if(firstVideo){
      items = [firstVideo, ...items];
    }
    
    items = [...items, ...relatedCollectionVideos];

    //remove duplicated items based on video url
    const seen = new Set();
    items = items.filter(item => {
      if (seen.has(item.video)) return false;
      seen.add(item.video);
      return true;
    });

    this.sortedVideos = items;


  
    

    //add articles to the slider
    for(var i = 0; i < items.length; i++){
      var article = items[i];
      var template = $(`<div class="product-related-information" >
        ${article.url ? `<a href="${article.url}" class="js-analytics-trigger" data-analytics-name="related_videos_click" >` : ''}
          <div class="product-related-information-image-container">
            <img alt="${article.title}" height="300" width="300" class="responsive-image-element" loading="lazy" src="${article.thumb}">
            <span data-src="#product-related-video-player-popup"
              data-title="${article.title}"
              data-thumb="${article.thumb}"
              data-category="${article.category}"
              data-video-type="${article.videoType}"
              data-video="${article.video}" class="product-related-video-play-icon js-product-related-video-play-icon js-related-video-play js-analytics-trigger" data-analytics-name="related_videos_click">
              <span class="oi" data-glyph="play-circle"></span>
            </span>
          </div>
          <div class="product-related-information-text">
            <span class="product-related-information-category">${article.category}</span>
            <h4 class="product-related-information-title">${article.title}</h4>
          </div>
        ${article.url ? `</a>` : ''}

      </div>`)

      this.$videosContainer.append(template);
    }

    if (this.openPopup) {
      this.buildPlaylist(items);
    }

    this.slickInit();
  }

  slickInit() {
    let slickSettings = {
      accessibility: true,
      slidesToShow: 4,
      infinite: true,
      slidesToScroll: 1,
      prevArrow:
        '<a aria-label="Previous" class="prev-button arrow-btn" href="#"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-left" viewBox="0 0 20 38"><path d="M4.068 18.649l15.466 16.105c.31.283.466.629.466 1.039 0 .41-.155.77-.466 1.08a1.412 1.412 0 0 1-1.038.424c-.41 0-.756-.141-1.038-.424L.466 19.708A1.373 1.373 0 0 1 0 18.648c0-.423.155-.776.466-1.059L17.458.424A1.412 1.412 0 0 1 18.496 0c.41 0 .755.141 1.038.424.31.282.466.636.466 1.06 0 .423-.155.776-.466 1.059L4.068 18.649z" fill="#726D75" fill-rule="evenodd"/></svg></a>',
      nextArrow:
        '<a aria-label="Next" class="next-button arrow-btn" href="#"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 20 38"><path d="M15.932 18.649L.466 2.543A1.35 1.35 0 0 1 0 1.505c0-.41.155-.77.466-1.081A1.412 1.412 0 0 1 1.504 0c.41 0 .756.141 1.038.424l16.992 17.165c.31.283.466.636.466 1.06 0 .423-.155.777-.466 1.06L2.542 36.872a1.412 1.412 0 0 1-1.038.424c-.41 0-.755-.141-1.038-.424A1.373 1.373 0 0 1 0 35.813c0-.423.155-.776.466-1.059L15.932 18.65z" fill="#726D75" fill-rule="evenodd"/></svg></a>',
      arrows: true,
      responsive: [
        {
          breakpoint: 768,
          settings: "unslick"
        }
      ]
    }

    let wrapper = this.wrapper;
    let $videosContainer = this.$videosContainer;

    $videosContainer.on('init', function(){
      wrapper.classList.add('is-initializing');
      setTimeout(function(){
        wrapper.classList.remove('is-initializing');
        wrapper.classList.add('initialized');
        if($(window).width() > 768){
          $videosContainer.slick('refresh')
        }
      }, 2000)
    })

    $videosContainer.slick(slickSettings)
  }

}

customElements.define('related-videos', RelatedVideos);